import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/Button";
import { selectPageData } from "../../../../../../../../redux/reducers/navigationSlice";
import {
  userAnswer,
  saveActivity,
} from "../../../../../../../../redux/reducers/userAnswersReducer";
import { adminData } from "../../../../../../../../redux/reducers/adminReducer";
import Frame from "./components/Frame";
import {
  clearActivityDraft,
  getActivityDraft,
  saveActivityDraft,
} from "../../../utils/activityDrafts";

function Page6() {
  const pageData = useSelector(selectPageData);
  const dispatch = useDispatch();
  const [answers, setAnswers] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const adminDatas = useSelector(adminData);
  const userAnswers = useSelector(userAnswer);

  // Load user answers (normalize them to always use `id`)
  useEffect(() => {
    if (!userAnswers) return;
    const response = userAnswers.activities?.find(
      (item) => item.page === pageData.id
    );
    const draftAnswer = getActivityDraft(userAnswers, pageData.id);

    const savedAnswer = Array.isArray(response?.answer)
      ? response.answer
      : Array.isArray(draftAnswer)
        ? draftAnswer
        : null;

    if (!savedAnswer) {
      setAnswers([]);
      return;
    }

    // Normalize any legacy data that might use stepId instead of id
    const normalized = savedAnswer.map((item) =>
      item.id
        ? item
        : item.stepId
        ? { ...item, id: item.stepId }
        : { ...item, id: pageData.id }
    );

    setAnswers(normalized);
  }, [userAnswers, pageData.id]);

  useEffect(() => {
    if (!answers.length) return;
    saveActivityDraft(userAnswers, pageData.id, answers);
  }, [answers, pageData.id, userAnswers]);

  const saveUserInput = () => {
    if (adminDatas?.isAdmin) return true;

    // Find answers for the current page
    const stepData = answers.find((item) => item.id === pageData.id);

    if (!stepData) {
      setErrorMessage("Oops! All inputs must be filled out.");
      return false;
    }

    // Dynamically get all question types for this page
    const requiredFields = Array.isArray(pageData.questions)
      ? pageData.questions.map((q) => q.type)
      : [];

    // Check if all required fields are filled
    const missingFields = requiredFields.filter(
      (field) => !stepData[field] || stepData[field].trim() === ""
    );

    if (missingFields.length > 0) {
      setErrorMessage(
        `Please fill out all inputs. Missing: ${missingFields.join(", ")}.`
      );
      return false;
    }

    setErrorMessage("");
    const activityData = {
      page: pageData.id,
      answer: answers,
    };

    dispatch(saveActivity(activityData));
    clearActivityDraft(userAnswers, pageData.id);
    return true;
  };

  return (
    <>
      <Frame
        data={{
          step: pageData.id,
          questions: pageData.questions,
          question: pageData.question,
        }}
        setErrorMessage={setErrorMessage}
        answers={answers}
        setAnswers={setAnswers}
      />
      {errorMessage && <div className="text-danger">{errorMessage}</div>}
      <div className="d-flex justify-content-center gap-96px mt-4 gap-4">
        <Button text="Prev" />
        <Button text="Next" customOnClick={saveUserInput} />
      </div>
    </>
  );
}

export default Page6;
